import React, { useContext, useEffect, useState } from "react";
import {
  IonItem,
  IonLabel,
  IonPage,
  IonRow,
  IonCol,
  IonContent,
  IonCard,
  IonCardHeader,
  IonCardContent,
  IonGrid,
  IonIcon,
  IonImg,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonBackButton,
  IonLoading,
  IonTitle,
  IonChip,
  IonCardTitle,
  IonCardSubtitle,
  IonButton,
} from "@ionic/react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import "./UserProfile.css";
import ReadingsComponent from "../../components/ReadingsComponent";
import { useHistory, useLocation } from "react-router";
import { convertArrayToObject, convertInches } from "./../../services/Helpers";
import { arrowBackCircleSharp, create } from "ionicons/icons";
import LatestReadings from "../Readings/LatestReadings";
import TotalReadingsChart from "../../components/Charts/TotalReadingsChart";
import MeasurementChart from "../../components/Charts/MeasurementChart";
import TotalReadingsPieChart from "../../components/Charts/TotalReadingsPieChart";
import GroupedReadingMethodChart from "../../components/Charts/GroupedReadingMethodChart";
import { Box, Button, Card, CardActions, CardContent, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, InputLabel, Typography } from "@mui/material";
import { DefaultThreshold } from "../../components/UsersThreshold/DefaultThreshold";
import { DefaultState } from "../Threshold/ThresholdModel";
import { formValidation } from "../../components/FormField/FormValidation";
import { ApplicationContext, ProviderContext } from "../../ApplicationState";
import { format } from "date-fns";
import { isEmpty } from "@aws-amplify/core";
import { useUserProfile } from "./useUserProfile";
import { LoadingState } from "../../types";
import * as ApiService from "../../services/ApiService";
import { Model } from "survey-core";
import { useTranslations } from "../../hooks/useTranslations";
import { useTranslation } from "react-i18next";

var _ = require("lodash");

const UserProfile: React.FC<any> = (props) => {
  const history: any = useHistory();
  const location: any = useLocation();
  const labels = useTranslations()

  const { fetchSelectedUserMeasurement, fetchUserProviders } = useUserProfile();
  const [selectedUser, setSelectedUser] = useState({});
  console.log("selectedUser ===> ", selectedUser)
  const [displayName, setDisplayName] = useState("");
  const [showLoading, setShowLoading] = useState(true);
  const [measurementValues, setMeasurementValues] = useState({});
  const [defaultValues, setDefaultValues] = React.useState<DefaultState>({
    bloodPressureSystolicMin: "",
    bloodPressureSystolicMax: "",
    bloodPressureDiastolicMin: "",
    bloodPressureDiastolicMax: "",
    weightMin: "",
    weightMax: "",
    temperatureMin: "",
    temperatureMax: "",
    oxygenMin: "",
    oxygenMax: "",
    bloodGlucoseMin: "",
    bloodGlucoseMax: "",
    bloodSaturation: "",
    pulseMin: "",
    pulseMax: "",
  });
  const [fieldDisabled, setFieldDisabled] = useState(true);
  const [inputChange, setInputChange] = useState(false);
  const { userState } = useContext(ApplicationContext);
  const { providerState } = useContext(ProviderContext)

  const [providers, setProvider] = useState([]);
  const [userData, setUserData] = useState(null);
  const [userSurveyResponse, setUserSurveyResponse] = useState(null);
  const [userScheduleResponse, setUserScheduleResponse] = useState(null);
  // const [emrRecord, setEmrRecord] = useState(null);
  const { i18n, t } = useTranslation();
  const lang = i18n.language;

  const [epicUser, setEpicUser] = useState({
    user: null,
    EMRlinked: false
  });

  let measurement = [];

  function updateDisplayName(selectedUser) {
    let userAttributes: any = selectedUser;
    if (userAttributes !== undefined) {
      let given_name = userAttributes.given_name;
      let family_name = userAttributes.family_name;
      setDisplayName(given_name + " " + family_name);
      setShowLoading(false);
    }
  }

  useEffect(() => {
    setShowLoading(true)
    if (_.isEmpty(location.state.userId)) {
      setShowLoading(false)
      return;
    }
    getmeasurement()
    getUserProviders()
    getSurveyResponse()
    getScheduleResponse()
    getApprovedEMRRecord()
  }, [providerState.providerId]);

  useEffect(() => {
    if (!selectedUser || !userData?.thresholds) return;
    setThresholdValue(userData?.thresholds);
  }, [selectedUser, providerState.providerId]);


  const getApprovedEMRRecord = async () => {
    try {
      const data = await ApiService.fetchEMRApprovedData(userState.authenticatedUser, location?.state?.userId, providerState.providerId);
      if (data) {
        setEpicUser({
          user: data,
          EMRlinked: true
        })
      }
    } catch (error) {
      setShowLoading(false)
    } finally {
      setShowLoading(false);
    }
  }

  const getEMRRecord = async () => {
    setShowLoading(true);
    try {
      const data = await ApiService.fetchEMRTempData(userState.authenticatedUser, location?.state?.userId, providerState.providerId);
      if (data === 'User not found') {
        setOpen(true)
        setShowLoading(false);
        return
      }

      if (data.length > 0) {
        const filterById = _.find(data, r => r.userId === location?.state?.userId)
        setEpicUser({
          user: filterById,
          EMRlinked: false
        })
        // setEmrRecord(filterById)
        setOpen(true)
        setShowLoading(false)
      }
    } catch (error) {
      setShowLoading(false)
    } finally {
      setOpen(true)
      setShowLoading(false);
    }
  }

  const getScheduleResponse = () => {
    try {
      ApiService.getScheduledNotificationsByUserId(userState.authenticatedUser, location?.state?.userId, providerState.providerName).then((res) => {
        const schedulesOrderByDate = _.orderBy(res, [(v) => new Date(v.scheduleDate)], ['desc']);
        setUserScheduleResponse(schedulesOrderByDate)
      })
    } catch (ex) {
    }
  }

  const transformSurveyData = (surveypages, surveys) => {

    return surveypages.flatMap((page) =>
      page.elements
        .filter((element) => surveys[element.name] !== undefined)
        .map((element) => {

          let value = surveys[element.name];

          // Handle radiogroup choices
          if (element.type === "radiogroup" && typeof value === "string") {
            const choice = element.choices.find((c) => c.value === value);
            value = choice?.text || value; // Map value to text if available

          }

          if (element.type === "checkbox") {
            value = _.map(value, v => {
              const choice = element.choices.find((c) => c.value === v);
              return choice?.text || value; // Map value to text if available
            })

          }

          if (element.type === "dropdown" && typeof value === "string") {
            const choice = element.choices.find((c) => c.value === value);
            value = choice?.text || value; // Map value to text if available

          }

          return {
            name: element.name,
            title: element.title,
            value,
          };
        })

    );
  }

  const getSurveyResponse = () => {
    try {
      ApiService.getSurveyResultByUserId(userState.authenticatedUser, location?.state?.userId, providerState.providerId).then((res) => {
        //console.log("🚀 ~ ApiService.getSurveyResultByUsers ~ res:", res)

        if (res) {

          const result = _.map(res, sur => {
            const surveys = JSON.parse(sur?.surveyResult?.surveyData)
            //console.log("🚀 ~ ApiService.getSurveyResultByUsers ~ surveys:", surveys)

            const surveyJson = JSON.parse(sur?.survey?.jsonData)

            const pages = surveyJson.pages

            const resultdata = transformSurveyData(pages, surveys)
            // const survey = new Model(surveyJson);

            const data = {
              surveyName: sur?.survey?.name,
              completedOn: sur?.surveyResult?.completedOn,
              surveyResult: surveys,
              surveyDataToRender: resultdata,
              surveyJson: surveyJson
            }

            return data
          })

          const filterEmptySurveyResponse = _.filter(result, r => !_.isEmpty(r.surveyDataToRender))

          setUserSurveyResponse(filterEmptySurveyResponse)


        }
      }).catch(err => {
      })
    } catch (ex) {
    }
  }

  const getmeasurement = () => {
    fetchSelectedUserMeasurement(location.state.userId).then((data) => {
      setShowLoading(false)
      if (data) {
        setUserData(data);
        const threshold = _.orderBy(data.thresholds, ['updatedOn'], ['desc'])
        const thresholdLength = threshold.length === 1;
        setMeasurementValues(data.measurements);
        setThresholdValue(_.take(threshold, 13))
        var result = convertArrayToObject(data.attributes, "name");
        result.enabled = data.enabled;
        setSelectedUser(result);
        updateDisplayName(result);

      }
    }).catch(ex => setShowLoading(false))
  }

  const getUserProviders = () => {
    fetchUserProviders(location.state.userId).then(data => {
      const providers = _.map(data, prov => prov.providerCode)
      setProvider(providers)
    })
  }

  const setThresholdValue = (threshold) => {
    const diastolicMin = threshold.find(v => {
      const sameProviderCode = v.providerCode === providerState.providerId
      return sameProviderCode ? v.measurementTypePart.longName === 'Diastolic' && v.thresholdType === 0 : ''
    })
    const diastolicMax = threshold.find(v => {
      const sameProviderCode = v.providerCode === providerState.providerId
      return sameProviderCode ? v.measurementTypePart.longName === 'Diastolic' && v.thresholdType === 1 : ''
    })
    const systolicMin = threshold.find(v => {
      const sameProviderCode = v.providerCode === providerState.providerId
      return sameProviderCode ? v.measurementTypePart.longName === 'Systolic' && v.thresholdType === 0 : ''
    })
    const systolicMax = threshold.find(v => {
      const sameProviderCode = v.providerCode === providerState.providerId
      return sameProviderCode ? v.measurementTypePart.longName === 'Systolic' && v.thresholdType === 1 : ''
    })
    const WeightMin = threshold.find(v => {
      const sameProviderCode = v.providerCode === providerState.providerId
      return sameProviderCode ? v.measurementTypePart.longName === 'Weight' && v.thresholdType === 0 : ''
    })
    const WeightMax = threshold.find(v => {
      const sameProviderCode = v.providerCode === providerState.providerId
      return sameProviderCode ? v.measurementTypePart.longName === 'Weight' && v.thresholdType === 1 : ''
    })
    const TempMin = threshold.find(v => {
      const sameProviderCode = v.providerCode === providerState.providerId
      return sameProviderCode ? v.measurementTypePart.longName === 'Temperature' && v.thresholdType === 0 : ''
    })
    const TempMax = threshold.find(v => {
      const sameProviderCode = v.providerCode === providerState.providerId
      return sameProviderCode ? v.measurementTypePart.longName === 'Temperature' && v.thresholdType === 1 : ''
    })
    const OxygenMin = threshold.find(v => {
      const sameProviderCode = v.providerCode === providerState.providerId
      return sameProviderCode ? v.measurementTypePart.longName === 'Oxygen Saturation' && v.thresholdType === 0 : ''
    })
    const SugarMin = threshold.find(v => {
      const sameProviderCode = v.providerCode === providerState.providerId
      return sameProviderCode ? v.measurementTypePart.longName === 'Sugar' && v.thresholdType === 0 : ''
    })
    const SugarMax = threshold.find(v => {
      const sameProviderCode = v.providerCode === providerState.providerId
      return sameProviderCode ? v.measurementTypePart.longName === 'Sugar' && v.thresholdType === 1 : ''
    })
    const PulseMin = threshold.find(v => {
      const sameProviderCode = v.providerCode === providerState.providerId
      return sameProviderCode ? v.measurementTypePart.longName === 'PulseRate' && v.thresholdType === 0 : ''
    })
    const PulseMax = threshold.find(v => {
      const sameProviderCode = v.providerCode === providerState.providerId

      return sameProviderCode ? v.measurementTypePart.longName === 'PulseRate' && v.thresholdType === 1 : ''
    })
    setDefaultValues({
      bloodPressureSystolicMin: systolicMin !== undefined ? systolicMin.thresholdValue : '',
      bloodPressureSystolicMax: systolicMax !== undefined ? systolicMax.thresholdValue : '',
      bloodPressureDiastolicMin: diastolicMin !== undefined ? diastolicMin.thresholdValue : '',
      bloodPressureDiastolicMax: diastolicMax !== undefined ? diastolicMax.thresholdValue : '',
      weightMin: WeightMin !== undefined ? WeightMin.thresholdValue : '',
      weightMax: WeightMax !== undefined ? WeightMax.thresholdValue : '',
      temperatureMin: TempMin !== undefined ? TempMin.thresholdValue : '',
      temperatureMax: TempMax !== undefined ? TempMax.thresholdValue : '',
      oxygenMin: '',
      oxygenMax: '',
      bloodGlucoseMin: SugarMin !== undefined ? SugarMin.thresholdValue : '',
      bloodGlucoseMax: SugarMax !== undefined ? SugarMax.thresholdValue : '',
      bloodSaturation: OxygenMin !== undefined ? OxygenMin.thresholdValue : '',
      pulseMin: PulseMin !== undefined ? PulseMin.thresholdValue : '',
      pulseMax: PulseMax !== undefined ? PulseMax.thresholdValue : '',
    });
  }

  function editProfile(profile) {
    history.push("/updateprofile", { user: profile });
  }

  const handleDefaultChange =
    (prop: keyof DefaultState) =>
      (event: React.ChangeEvent<HTMLInputElement>) => {
        const isMatch = formValidation(event);
        if (!isMatch) {
          return event.preventDefault;
        }
        setInputChange(true);
        setDefaultValues({ ...defaultValues, [prop]: event.target.value });
      };
  const handleDefaultEditFields = () => {
    setFieldDisabled(false);
  };

  if (inputChange) {
    if (!_.isEmpty(location.state) || location.state != undefined) {
      const thresholdLength = userData.thresholds.length === 1;
      let tempMin = {};
      if (!thresholdLength) {
        measurement = userData.thresholds.map((value) => {
          const { measurementTypePart, thresholdAlerts } = value;
          const fullName =
            userState.authenticatedUser.attributes.given_name +
            " " +
            userState.authenticatedUser.attributes.family_name;
          const date = new Date();
          const updatedDate = format(date, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx");
          switch (measurementTypePart.longName) {
            case "Systolic":
              if (value.thresholdType === 0) {
                const systolicMin = {
                  ...value,
                  thresholdValue: defaultValues.bloodPressureSystolicMin,
                  updatedBy: fullName,
                  updatedOn: updatedDate,
                };
                return systolicMin;
              } else {
                const systolicMAX = {
                  ...value,
                  thresholdValue: defaultValues.bloodPressureSystolicMax,
                  updatedBy: fullName,
                  updatedOn: updatedDate,
                };
                return systolicMAX;
              }
            case "Diastolic":
              if (value.thresholdType === 0) {
                const diastolicMin = {
                  ...value,
                  thresholdValue: defaultValues.bloodPressureDiastolicMin,
                  updatedBy: fullName,
                  updatedOn: updatedDate,
                };
                return diastolicMin;
              } else {
                const diastolicMax = {
                  ...value,
                  thresholdValue: defaultValues.bloodPressureDiastolicMax,
                  updatedBy: fullName,
                  updatedOn: updatedDate,
                };
                return diastolicMax;
              }

            case "Sugar":
              if (value.thresholdType === 0) {
                const sugarMin = {
                  ...value,
                  thresholdValue: defaultValues.bloodGlucoseMin,
                  updatedBy: fullName,
                  updatedOn: updatedDate,
                };
                return sugarMin;
              } else {
                const sugarMAX = {
                  ...value,
                  thresholdValue: defaultValues.bloodGlucoseMax,
                  updatedBy: fullName,
                  updatedOn: updatedDate,
                };
                return sugarMAX;
              }

            case "PulseRate":
              if (value.thresholdType === 0) {
                const pulseMin = {
                  ...value,
                  thresholdValue: defaultValues.pulseMin,
                  updatedBy: fullName,
                  updatedOn: updatedDate,
                };
                return pulseMin;
              } else {
                const pulseMAX = {
                  ...value,
                  thresholdValue: defaultValues.pulseMax,
                  updatedBy: fullName,
                  updatedOn: updatedDate,
                };
                return pulseMAX;
              }

            case "Temperature":
              const thresholdID = {
                ...thresholdAlerts[0],
                id: 0,
                providerThresholdId: 0,
                providerThresholdAlertId: 0,
              };
              if (value.thresholdType === 0) {
                const temperatureMin = {
                  ...value,
                  thresholdType: 0,
                  thresholdValue: defaultValues.temperatureMin,
                  updatedBy: fullName,
                  updatedOn: updatedDate,
                };
                return temperatureMin;
              } else {
                const temperatureMax = {
                  ...value,
                  thresholdType: 1,
                  thresholdValue: defaultValues.temperatureMax,
                  updatedBy: fullName,
                  updatedOn: updatedDate,
                };
                tempMin = {
                  ...value,
                  id: 0,
                  thresholdType: 0,
                  thresholdAlerts: [thresholdID],
                  thresholdValue: defaultValues.temperatureMin,
                  updatedBy: fullName,
                  updatedOn: updatedDate,
                };
                return temperatureMax;
              }

            case "Weight":
              if (value.thresholdType === 0) {
                const weightMin = {
                  ...value,
                  thresholdValue: defaultValues.weightMin,
                  updatedBy: fullName,
                  updatedOn: updatedDate,
                };
                return weightMin;
              } else {
                const weightMAX = {
                  ...value,
                  thresholdValue: defaultValues.weightMax,
                  updatedBy: fullName,
                  updatedOn: updatedDate,
                };
                return weightMAX;
              }

            case "Oxygen Saturation":
              if (value.thresholdType === 0) {
                const oxygen = {
                  ...value,
                  thresholdValue: defaultValues.bloodSaturation,
                  updatedBy: fullName,
                  updatedOn: updatedDate,
                };
                return oxygen;
              }
              break;
            default:
              break;
          }
        });

        if (measurement.length === 12) {
          measurement.push(tempMin);
        }
      }
    } else {
      console.log("usermeasurement is empty");
    }
  }

  const goToUserSurveyResponse = () => {
    history.push("/userSurveyResponses", { userSurveyResponses: userSurveyResponse });
  }

  const goToUserScheduleResponse = () => {
    history.push("/userScheduleResponses", { userScheduleResponses: userScheduleResponse });
  }

  const updateEMRUser = async (selectedRow: any) => {
    // setShowLoading(false)
    // setEpicUser({
    //   user: epicUser?.user,
    //   EMRlinked: true
    // })
    // handleClose()


    try {
      const data = await ApiService.updateUserEMRData(userState.authenticatedUser, selectedRow);
      if (data) {
        setEpicUser({
          user: data?.data,
          EMRlinked: true
        })
      }
    } catch (error) {
      setShowLoading(false)
      alert("Linking to EMR failed. Please try again or contact support.");
    } finally {
      handleClose()
      setShowLoading(false)
    }

  };

  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getDOB = (dob) => {
    if (_.isEmpty(dob)) return
    const dateOnly = dob.split("T")[0];
    return dateOnly
  }

  return (
    <IonPage>
      <Header />
      <IonHeader>
        <IonToolbar color="light">
          <IonButtons slot="start">
            <IonBackButton
              text={labels.Goback}
              icon={arrowBackCircleSharp}
              defaultHref="/"
            />
          </IonButtons>
          <IonTitle>{labels.Profile}</IonTitle>
        </IonToolbar>
      </IonHeader>
      {_.isEmpty(location.state) ? (
        <CircularProgress
          size={24}
          sx={{
            color: "#3880ff",
            position: "absolute",
            top: "50%",
            left: "50%",
            marginTop: "-12px",
            marginLeft: "-12px",
          }}
        />
      ) : (
        <IonContent>
          <IonGrid>
            <IonCol>
              <IonCol className="col-4">
                <IonCard className="fill-vertical-space">
                  <IonCardHeader>
                    <IonItem>
                      <h3>
                        {displayName} (
                        {selectedUser["enabled"] ? labels.Active : labels.Deactivated})
                      </h3>

                      {/* {providerState?.emrType === 'Epic' && (
                        <Button
                          style={{
                            marginLeft: 20,
                            backgroundColor: epicUser?.EMRlinked ? 'green' : '#165fc7',
                            fontWeight: 'bold'
                          }}
                          onClick={() => {
                            if (epicUser?.EMRlinked) {
                              //alert('Already Linked to EMR.')
                              setOpen(true)
                              return
                            }
                            getEMRRecord()
                          }}
                          variant='contained'
                          size="small">{epicUser?.EMRlinked ? "Linked to EMR" : "Link to EMR"}</Button>
                      )} */}

                      <IonIcon
                        className="link"
                        icon={create}
                        color="primary"
                        slot="end"
                        onClick={(e: any) => editProfile(selectedUser)}
                      />
                    </IonItem>

                  </IonCardHeader>
                  <IonCardContent style={{ backgroundColor: 'white' }}>
                    <IonRow>
                      {/* <IonCol sizeXs="12" sizeSm="12" sizeMd="12"> */}
                      <IonImg
                        className="profile-img"
                        src={
                          selectedUser["picture"] !== "" &&
                            selectedUser["picture"] !== null
                            ? "data:image/jpeg;base64," +
                            selectedUser["picture"]
                            : "/assets/img/noimageavailable.png"
                        }
                      />
                      {/* style={{ fontSize: 16, fontStyle: 'italic' }} */}
                      {/* style={{ fontSize: 16, fontFamily: 'bold', fontStyle: 'normal' }} */}

                      {/* </IonCol> */}
                      <IonRow>

                        <IonGrid>
                          <IonCol>
                            <IonItem>
                              <IonLabel className="profile-header">{labels.Name}<IonLabel className="profile-sub">{displayName}</IonLabel></IonLabel>
                            </IonItem>

                            <IonItem>
                              <IonLabel className="profile-header">
                                {labels.Birthdate} <IonLabel className="profile-sub"> {selectedUser["birthdate"]}</IonLabel>
                              </IonLabel>
                            </IonItem>
                            <IonItem>
                              <IonLabel className="profile-header">
                                {labels.PhoneNumber} <IonLabel className="profile-sub">{selectedUser["phone_number"]}</IonLabel>
                              </IonLabel>
                            </IonItem>
                            {userState?.authenticatedUser?.attributes['custom:Roles'] !== "Provider" && (
                              <IonItem>
                                <IonLabel className="profile-header">
                                  {labels.ProviderCode} <IonRow>
                                    {_.map(providers, (prov, index) => (
                                      // <IonCol key={index} size="12"> {/* size="12" makes it full width */}
                                      <IonChip>{prov}</IonChip>
                                      // </IonCol>
                                    ))}
                                  </IonRow>
                                </IonLabel>

                              </IonItem>
                            )}
                          </IonCol>
                        </IonGrid>

                        <IonGrid>
                          <IonCol>
                            {selectedUser["custom:Roles"] !== undefined ? (
                              <IonItem >
                                <IonLabel className="profile-header">
                                  {labels.Roles} <IonLabel className="profile-sub">{selectedUser["custom:Roles"]}</IonLabel>
                                </IonLabel>
                              </IonItem>
                            ) : (
                              <IonLabel className="profile-sub">{'N/A'}</IonLabel>
                            )}

                            <IonRow>
                              <IonItem>
                                <IonLabel className="profile-header">{labels.Gender} <IonLabel className="profile-sub">{selectedUser["gender"] ? selectedUser["gender"] : 'N/A'}</IonLabel> </IonLabel>
                              </IonItem>
                              <IonItem>
                                <IonLabel className="profile-header">
                                  {labels.Height} <IonLabel className="profile-sub">{convertInches(selectedUser["custom:height"])}</IonLabel>
                                </IonLabel>
                              </IonItem>
                            </IonRow>
                            <IonItem>
                              <IonLabel className="profile-header">{labels.Email}  <IonLabel className="profile-sub">{selectedUser["email"]}</IonLabel></IonLabel>
                            </IonItem>
                          </IonCol>
                        </IonGrid>
                      </IonRow>
                      <IonCol>
                        <Card
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            padding: '5px',
                            background: 'linear-gradient(to right,rgb(252, 104, 68),rgb(247, 200, 164))',
                            height: 100,
                            marginTop: 10,
                            width: '70%'
                          }}>
                          <CardContent>
                            <Typography variant="h5" component="div">
                              {labels.SurveyResponses}
                            </Typography>
                            <Typography variant="body2">
                              {displayName} {labels.HasRespondedToSurveys} {_.isEmpty(userSurveyResponse) ? 0 : userSurveyResponse.length} {labels.Survey}s
                            </Typography>
                          </CardContent>
                          <CardActions>
                            <Button
                              onClick={() => {
                                goToUserSurveyResponse()
                              }}
                              variant='contained'
                              size="small">{labels.ViewResponses}</Button>
                          </CardActions>
                        </Card>

                        <Card style={{
                          display: 'flex',
                          alignItems: 'center',
                          padding: '5px',
                          background: 'linear-gradient(to right,rgb(252, 104, 68),rgb(247, 200, 164))',
                          height: 100,
                          marginTop: 10,
                          width: '70%'
                        }}>
                          <CardContent>
                            <Typography variant="h5" component="div">
                              {labels.NotificationResponses}
                            </Typography>
                          </CardContent>
                          <CardActions>
                            <Button
                              onClick={() => {
                                goToUserScheduleResponse()
                              }}
                              variant='contained'
                              size="small">{labels.ViewResponses}</Button>
                          </CardActions>
                        </Card>
                      </IonCol>
                    </IonRow>
                  </IonCardContent>
                </IonCard>
              </IonCol>
              {/* <IonCol className="col-8"> */}
              <IonCard>
                <DefaultThreshold
                  defaultValues={defaultValues}
                  fieldDisabled={fieldDisabled}
                  handleDefaultChange={handleDefaultChange}
                  handleDefaultEditFields={handleDefaultEditFields}
                  setFieldDisabled={setFieldDisabled}
                  measurement={measurement}
                  userState={userState}
                  providerData={userData}
                  inputChange={inputChange}
                  user={location?.state?.user}
                  global={false}
                />
              </IonCard>
            </IonCol>

            <IonRow>
              <IonCol className="col-12">
                {userData && (
                  <LatestReadings type="User" selectedUser={userData} />
                )}
              </IonCol>
              <IonCol className="col-12">
                <IonRow className="ion-charts">
                  <IonCard className=" col-5" >
                    <IonCardHeader>
                      <IonItem>
                        <h3>{labels.Readingcountlast30days}</h3>
                      </IonItem>
                    </IonCardHeader>
                    <IonCardContent>
                      <TotalReadingsPieChart
                        userId={selectedUser["sub"]}
                        type="User"
                        translationLabels={labels}
                        lang={lang}
                      />
                    </IonCardContent>
                  </IonCard>

                  <IonCard className=" col-5">
                    <IonCardHeader>
                      <IonItem>
                        <h3>{labels.Latest10Readings}</h3>
                      </IonItem>
                    </IonCardHeader>
                    <IonCardContent>
                      <MeasurementChart
                        userId={selectedUser["sub"]}
                        type="User"
                      />
                    </IonCardContent>
                  </IonCard>
                </IonRow>
              </IonCol>
            </IonRow>
          </IonGrid>
          <ReadingsComponent selectedUser={selectedUser} />
          <IonLoading isOpen={showLoading} />
        </IonContent>
      )}

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: { width: '600px', maxWidth: 'none' }, // customize width here
        }}
      >
        <DialogTitle id="alert-dialog-title">
          {epicUser?.user ? "EMR Record" : "EMR record not found"} for {displayName}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2, // spacing between fields
                mt: 1,

                //width: 'fit-content',
              }}
            >
              <Box>
                <Typography variant="subtitle2" color="textPrimary">{labels.Name}:-</Typography>
                <Typography variant="body1" color="black">
                  {epicUser?.user?.fullName || 'N/A'}
                </Typography>
              </Box>

              <Box>
                <Typography variant="subtitle2" color="textPrimary">{labels.DateOfBirth}:-</Typography>
                <Typography variant="body1" color="black">
                  {getDOB(epicUser?.user?.dateOfBirth) || epicUser?.user?.dob || 'N/A'}
                </Typography>
              </Box>

              <Box>
                <Typography variant="subtitle2" color="textPrimary">{labels.Gender}:-</Typography>
                <Typography variant="body1" color="black">
                  {epicUser?.user?.gender || 'N/A'}
                </Typography>
              </Box>

              <Box>
                <Typography variant="subtitle2" color="textPrimary">{labels.Email}:-</Typography>
                <Typography variant="body1" color="black">
                  {epicUser?.user?.email || 'N/A'}
                </Typography>
              </Box>

              <Box>
                <Typography variant="subtitle2" color="textPrimary">{labels.Phone}:-</Typography>
                <Typography variant="body1" color="black">
                  {epicUser?.user?.phone || 'N/A'}
                </Typography>
              </Box>

              <Box>
                <Typography variant="subtitle2" color="textPrimary">Address:-</Typography>
                <Typography variant="body1" color="black">
                  {epicUser?.user?.addressJson || 'N/A'}
                </Typography>
              </Box>

              <Box>
                <Typography variant="subtitle2" color="textPrimary">FHIR Id:-</Typography>
                <Typography variant="body1" color="black">
                  {epicUser?.user?.fhiR_Resource_ID || 'N/A'}
                </Typography>
              </Box>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant='contained'
            onClick={() => {
              handleClose()
            }}>
            {'Close'}
          </Button>

          {epicUser?.user && (
            <Button
              disabled={(epicUser?.user) && (epicUser?.EMRlinked)}
              variant='contained'
              onClick={() => {
                updateEMRUser(epicUser?.user)
              }}
              style={{
                backgroundColor: (epicUser?.user) && (epicUser?.EMRlinked) ? 'green' : '#165fc7',
                color: 'white'
              }}
              autoFocus>
              {(epicUser?.user) && (epicUser?.EMRlinked) ? 'Linked' : 'Link to EMR'}
            </Button>
          )}

        </DialogActions>
      </Dialog>
    </IonPage>
  );
};

export default UserProfile;
